import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import idGenerator from 'react-id-generator'

// Lets import styles for component
import './SocialNetworks.sass'

const SocialNetworks = ({ socialNetworks }) => {
  return (
    <div className="socialNetworks">
      <ul>
        {socialNetworks.map(network => {
          return (
            <li 
              key={idGenerator()}
              className={classNames({
                socialItem: true,
                green: network.color === 'green',
                gray: network.color === 'gray',
              })}
            >
              <a 
                href={network.url}
                aria-label='icon'
              >
                <img src={network.icon.publicURL} alt=""/>
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default SocialNetworks

SocialNetworks.propTypes = {
  socialNetworks: PropTypes.array.isRequired,
}
